import AllIcons, {
  absolute_icon,
  close_icon,
  fixed_icon,
  relative_icon,
  static_icon,
  sticky_icon,
} from './AllIcons'

// layout_styles_keys
export const layout_styles_keys = [
  'display',
  'flex_direction',
  'align_items',
  'justify_content',
  'row_gap',
  'col_gap',
]

export const display_values = [
  {
    title: 'Block',
    desc: 'Creates a new line, stacking elements vertically within their parent container.',
    icon: AllIcons.block_icon,
    value: 'block',
  },
  {
    title: 'Flex',
    desc: 'Enables flexible layout, allowing elements to be organized horizontally or vertically within a container.',
    icon: AllIcons.flex_icon,
    value: 'flex',
  },
  {
    title: 'None',
    desc: 'Completely hides the element, removing it from the page layout.',
    icon: AllIcons.hide_icon,
    value: 'none',
  },
]
export const flex_direction = [
  {
    title: 'Horizontal',
    desc: 'Arranges flex items in a horizontal line from left to right.',
    value: 'row',
  },
  {
    title: 'Vertical',
    desc: 'Stacks flex items in a vertical column from top to bottom.',
    value: 'column',
  },
]
export const align_items = [
  {
    title: 'Start',
    desc: 'Aligns items at the top (for horizontal layout) or left (for vertical layout).',
    icon: AllIcons.align_start,
    value: 'start',
  },
  {
    title: 'Center',
    desc: 'Centers items both vertically and horizontally.',
    icon: AllIcons.align_center,
    value: 'center',
  },
  {
    title: 'End',
    desc: 'Aligns items at the bottom (for horizontal layout) or right (for vertical layout).',
    icon: AllIcons.align_end,
    value: 'end',
  },
  {
    title: 'Stretch',
    desc: 'Causes items to stretch and fill the available space.',
    icon: AllIcons.align_stretch,
    value: 'stretch',
  },
]

const justify_content_values = [
  {
    title: 'Start',
    desc: 'Aligns items at the left (for horizontal layout) or top (for vertical layout).',
    icon: AllIcons.justify_start,
    value: 'start',
  },
  {
    title: 'Center',
    desc: 'Centers items both horizontally and vertically.',
    icon: AllIcons.justify_center,
    value: 'center',
  },
  {
    title: 'End',
    desc: 'Aligns items at the right (for horizontal layout) or bottom (for vertical layout).',
    icon: AllIcons.justify_end,
    value: 'end',
  },
  {
    title: 'Space-Between',
    desc: 'Distributes items evenly along the horizontal or vertical axis with equal space between them.',
    icon: AllIcons.justify_space_between,
    value: 'space-between',
  },
  {
    title: 'Even',
    desc: 'Distributes items evenly along the horizontal or vertical axis with equal space around them.',
    icon: AllIcons.space_around,
    value: 'space-evenly',
  },
]

const flexWrapValues = [
  {
    title: 'No Wrap',
    desc: 'Items are not wrapped to the next line; they will stay on a single line, potentially overflowing their container.',
    value: 'nowrap',
  },
  {
    title: 'Wrap',
    desc: 'Items wrap to the next line if they exceed the container width, creating a new row or column as needed.',
    value: 'wrap',
  },
  {
    title: 'Wrap Reverse',
    desc: 'Items wrap to the next line in reverse order, creating a new row or column with the last item placed first.',
    value: 'wrap-reverse',
  },
]

// layout styles
export const layout_styles = [
  {
    key: 'display',
    value: 'flex',
    type: 'select',
    title: 'Display',
    drop_down_values: display_values,
    style_group: 'layout',
  },
  {
    key: 'flex_direction',
    value: 'column',
    type: 'select',
    title: 'Flex direction',
    style_group: 'layout',
    drop_down_values: flex_direction,
  },
  {
    key: 'align_items',
    title: 'Align items',
    type: 'select',
    value: 'start',
    is_required: false,
    drop_down_values: align_items,
    style_group: 'layout',
  },

  {
    key: 'justify_content',
    title: 'Justify content',
    type: 'select',
    value: 'start',
    is_required: false,
    drop_down_values: justify_content_values,
    style_group: 'layout',
  },
  {
    key: 'flex_wrap',
    value: 'nowrap',
    type: 'select',
    title: 'Flex wrap',
    drop_down_values: flexWrapValues,
    style_group: 'layout',
  },

  {
    key: 'row_gap',
    title: 'Gap between rows',
    type: 'input-px',
    value: '24px',
    is_required: false,
    style_group: 'layout',
  },
  {
    key: 'column_gap',
    title: 'Gap between columns',
    type: 'input-px',
    value: '24px',
    is_required: false,
    style_group: 'layout',
  },
]
